<template>
  <div class="dashboard">
    <ModalLoading :isLoading="isLoading" />

    <!-- CEO: dashboard estratégico propio -->
    <DashboardCEO v-if="role === 4" />

    <!-- Admin y Gerente: dashboard operativo estándar -->
    <BarChart v-if="role === 1 || role === 2" />

    <!-- Cajero -->
    <div v-if="role === 3">
      <BarChart />
    </div>
  </div>
</template>

<script>
import BarChart from "../components/DashboardList.vue";
import DashboardCEO from "../components/DashboardCEO.vue";
import ModalLoading from "@/components/ModalLoading.vue";
import { setPageTitle } from "@/components/pageMetadata";

export default {
  components: {
    BarChart,
    DashboardCEO,
    ModalLoading,
  },
  data() {
    return {
      titulo: "Bienvenido al Panel",
      role: Number(localStorage.getItem("role")) || 0,
    };
  },
  mounted() {
    setPageTitle("Inicio");
  },
  methods: {
    changeFavicon(iconPath) {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = iconPath;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

/* Estilos Generales */
* {
  font-family: "Montserrat", sans-serif;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Dashboard */
.dashboard {
  padding: 20px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  transition: all 0.3s ease;
}

/* Caja */
.box {
  background: #f5f5f5;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.box-header {
  margin-bottom: 15px;
}

.box-header h3 {
  margin: 0;
  color: #333;
  transition: color 0.3s ease;
}

/* Encabezados */
h3 {
  color: #333;
  font-size: clamp(18px, 3vw, 24px);
  transition: color 0.3s ease;
}

/* Contenido adicional */
.container-top {
  width: 100%;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

#campana {
  margin-right: 10px;
  font-size: 18px;
  color: #a38655;
  transition: color 0.3s ease;
}

.rol {
  color: #969696;
  font-size: 14px;
  transition: color 0.3s ease;
}

/* Botones de Navegación */
.navigate-button {
  margin-left: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.navigate-button:hover {
  background-color: #0056b3;
  transform: translateY(-2px);
}

/* =======================================================
   Modo Oscuro
======================================================= */
/* Dashboard en modo oscuro */
.dark .dashboard {
  background-color: #1e1e1e;
  color: #fff;
}

/* Cajas en modo oscuro */
.dark .box {
  background: #2d2d2d;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Encabezados en modo oscuro */
.dark h3,
.dark .box-header h3 {
  color: #c09d62;
}

/* Textos en modo oscuro */
.dark p {
  color: #fff;
}

/* Contenido adicional en modo oscuro */
.dark #campana {
  color: #a38655;
}

.dark .rol {
  color: #b0b0b0;
}

/* Botones en modo oscuro */
.dark .navigate-button {
  background-color: #c09d62;
  color: #1e1e1e;
}

.dark .navigate-button:hover {
  background-color: #a38655;
}

/* Gráficos en modo oscuro */
.dark .chart-container {
  background-color: #2d2d2d;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Media Queries */
/* Tablets grandes y laptops pequeñas */

@media screen and (max-width: 1024px) {
  .dashboard {
    padding: 16px;
    max-width: 100%;
  }

  h3 {
    font-size: clamp(16px, 2.5vw, 22px);
  }

  .box {
    margin-bottom: 16px;
  }
}

/* Tablets */
@media screen and (max-width: 768px) {
  .dashboard {
    padding: 14px;
  }

  .box {
    padding: 16px;
    margin-bottom: 14px;
  }

  .container-top {
    justify-content: center;
    margin: 12px 0;
    gap: 8px;
  }

  .navigate-button {
    margin: 4px;
    width: calc(50% - 8px); /* 2 botones por fila */
    max-width: 250px;
    font-size: 14px;
  }

  h3 {
    font-size: clamp(15px, 2.2vw, 20px);
  }

  .box-header {
    margin-bottom: 12px;
  }
}

/* Tablets pequeñas y teléfonos grandes */
@media screen and (max-width: 600px) {
  .dashboard {
    padding: 12px;
  }

  .box {
    padding: 14px;
    margin-bottom: 12px;
  }

  .navigate-button {
    width: 100%; /* 1 botón por fila */
    max-width: 100%;
    padding: 10px 16px;
  }

  h3 {
    font-size: clamp(14px, 2vw, 18px);
  }
}

/* Teléfonos */
/* Ajustes para móviles */
@media screen and (max-width: 480px) {
  .dashboard {
    display: grid;
    grid-template-columns: repeat(
      2,
      1fr
    ); /* Crear 2 columnas de igual tamaño */
    gap: 10px;
    padding: 10px;
  }

  .box {
    /* Reset de propiedades anteriores */
    width: 100%;
    margin: 0;
    padding: 12px;
    min-height: 100px;

    /* Nuevo layout */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  /* Ajustar tamaños de texto */
  .box h3 {
    font-size: 14px;
    margin-bottom: 4px;
  }

  .box p {
    font-size: 12px;
    margin: 4px 0;
  }

  /* Los gráficos deben ocupar todo el ancho */
  .chart-container,
  .barChart-container,
  div[class*="Chart"] {
    grid-column: 1 / -1;
    width: 100% !important;
  }

  /* Ajustar encabezados de sección */
  .dashboard > h3 {
    grid-column: 1 / -1;
    font-size: 16px;
    margin-bottom: 10px;
  }

  /* Ajustar los elementos de los boxes */
  .box i {
    font-size: 16px;
  }

  .box .number {
    font-size: 18px;
    font-weight: 600;
  }

  /* Links y botones dentro de los boxes */
  .box a,
  .box .btn {
    font-size: 12px;
    padding: 4px 8px;
    margin-top: 8px;
  }
}

/* Ajustes específicos para teléfonos pequeños */
@media screen and (max-width: 360px) {
  .dashboard {
    gap: 8px;
  }

  .box {
    padding: 8px;
    min-height: 90px;
  }

  .box h3 {
    font-size: 13px;
  }

  .box p {
    font-size: 11px;
  }

  .box .number {
    font-size: 16px;
  }
}

/* Para pantallas muy grandes */
@media screen and (min-width: 1440px) {
  .dashboard {
    max-width: 1600px;
    padding: 24px;
  }

  h3 {
    font-size: clamp(20px, 3.5vw, 28px);
  }

  .box {
    padding: 24px;
    margin-bottom: 24px;
  }
}

/* Para dispositivos en landscape */
@media screen and (max-height: 480px) and (orientation: landscape) {
  .dashboard {
    padding: 10px 15px;
  }

  .box {
    padding: 12px;
    margin-bottom: 10px;
  }

  .container-top {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .navigate-button {
    width: auto;
    padding: 6px 12px;
  }
}

/* Animaciones */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.box {
  animation: fadeIn 0.3s ease-out;
}
</style>
